<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>Trinkaを導入いただいたお客様</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../assets/images/plagiarism-check/clients/elsevier.png" width="66" height="72" loading="lazy" class="filter" alt="elsevier - 英文校正">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mit.svg" width="62" height="33" loading="lazy" class="filter" alt="mit - 文法 チェック">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/IEEE.svg" width="110" height="32" loading="lazy" class="filter" alt="IEEE - 文法 チェック">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/stanford.svg" width="99" height="44" loading="lazy"  class="filter" alt="stanford - 英文校正">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/wiley.svg" width="114" height="28" loading="lazy" class="filter" alt="wiley - 英文校正">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/harvard.png" width="130" height="33" loading="lazy" alt="harvard - 文法 チェック">
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mu.svg" width="115" height="40" loading="lazy" class="filter" alt="mu">
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/pfizer.svg" width="118" height="48" loading="lazy" class="filter" alt="pfizer - 英文チ ェッカー">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/abbott.svg" width="126" height="32" loading="lazy" class="filter" alt="abbott - 文法 チェック">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/princeton-white.svg" width="132" height="36" loading="lazy" alt="princeton - 英文校正">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>